import React, { ChangeEvent } from "react";
import { UploadDropzone, Images } from "@shared/components";

import "./index.scss";

const MAX_FILE_SIZE = 5 * 1024 * 1024; // 5MB
const ACCEPTED_FILES = {
  "image/png": [".png"],
  "image/jpeg": [".jpeg"],
  "image/jpg": [".jpg"],
};

export interface ImageUploadProps {
  label: string;
  image: string | null;
  onRemove: () => void;
  onUpload: (image: string, file: File) => void;
}

export const ImageUploader: React.FC<ImageUploadProps> = ({ label, image, onRemove, onUpload }) => {
  const handleImageUpload = (files: File[] | ChangeEvent<HTMLInputElement>) => {
    let file: File | null = null;

    if (Array.isArray(files)) {
      file = files[0]; // Handle drag-and-drop case
    } else {
      file = files.target.files?.[0] ?? null; // Handle input case
    }

    if (!file) return;

    const reader = new FileReader();
    reader.onload = () => {
      const previewUrl = reader.result as string;
      onUpload(previewUrl, file as File);
    };
    reader.readAsDataURL(file);
  };

  const acceptedExtensions = Object.values(ACCEPTED_FILES).flat().join(", ");

  return (
    <div className="image-upload">
      <label>{label}</label>
      <div className="image-section">
        {image ? (
          <Images list={[image]} onRemove={onRemove} />
        ) : (
          <div className="drag-n-drop">
            <UploadDropzone
              onDrop={handleImageUpload}
              maxSize={MAX_FILE_SIZE}
              multiple={false}
              className="pay-per-lead-buyer-dropzone"
              accept={ACCEPTED_FILES}
            >
              <div className="frame">
                <div className="drag-drop-text">
                  <span className="drag-drop-span"> Drag & Drop your file here or </span>
                  <span className="drag-drop-span browse">browse</span>
                  <span className="drag-drop-span"> . </span>
                </div>
                <div className="image-format-text">
                  Accepted file formats: {acceptedExtensions}. <br />
                  Max file size: {MAX_FILE_SIZE / 1024 / 1024} MB.
                </div>
              </div>
            </UploadDropzone>
          </div>
        )}
      </div>
    </div>
  );
};
